<adf-file-uploading-dialog *ngIf="showFileUploadingDialog$ | async" position="left">
</adf-file-uploading-dialog>